module.exports = __webpack_public_path__ + "img/7-1_02.cb74c466.jpg";